import { css } from "@emotion/react";
import settings from "@settings";

export const buttonContainer = css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'auto',
    height: 'auto%',
    textAlign: 'right',
    padding: settings.padding.medium,
    cursor: 'pointer'
})

export const fullButton = (disabled: boolean) => css({
    backgroundColor: disabled ? settings.colors.grey : settings.colors.light,
    padding: settings.padding.large,
    fontFamily: 'Coco Sharp',
    fontWeight: 700,
    fontSize: settings.fontSize.small,
    textTransform: 'uppercase',
    letterSpacing: '2px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: settings.sizes.small,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transformOrigin: 'left'
})

export const plainButton = (disabled: boolean) => css({
    // backgroundColor: disabled ? settings.colors.grey : settings.colors.light,
    padding: settings.padding.large,
    fontFamily: 'Coco Sharp',
    fontWeight: 900,
    fontSize: settings.fontSize.small,
    lineHeight: settings.fontSize.small,
    textTransform: 'uppercase',
    letterSpacing: '2px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: settings.sizes.small,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transformOrigin: 'left',
    color: settings.colors.dark
});


export const borderButton = (disabled: boolean) => css({
    border: `1px solid ${settings.colors.dark}`,
    padding: settings.padding.small,
    fontFamily: 'Coco Sharp',
    fontWeight: 900,
    fontSize: settings.fontSize.small,
    textTransform: 'uppercase',
    letterSpacing: '2px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: settings.sizes.small,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transformOrigin: 'left',
    color: settings.colors.dark
});